import order1        from '@/components/order/OrderCreate.vue'

import order2       from '@/components/order/OrderDelivery.vue'
import order3        from '@/components/order/OrdersSupplier.vue'
import order4        from '@/components/order/OrdersAllSuppliers.vue'
import order5        from '@/components/order/OrdersAllCategories.vue'

const flag = true
const menuId = 'bo2'
const routes = [
        
    {
        path        : '/order',
        name        : 'supplierOrder1',
        component   : order1,
        meta        : { name : 'Registrazione/Modifica Ordine', visible : flag ,icon : 'fas fa-edit',menu:menuId,color:'red'},
  
    },
  
    {
        path        : '/order_confirm',
        name        : 'supplierOrder2',
        component   : order2,
        meta        : { name : 'Consegna Ordine', visible : flag ,icon : 'fas fa-dolly',menu:menuId,color:'brown',divider:1},
  
    },
    {
        path        : '/order_supplier',
        name        : 'supplierOrder3',
        component   : order3,
        meta        : { name : 'Ordinato/Consegnato per fornitore', visible : flag ,icon : 'far fa-newspaper',menu:menuId,color:'green'},
  
    },
    {
        path        : '/order_all_suppliers',
        name        : 'supplierOrder4',
        component   : order4,
        meta        : { name : 'Ordinato/Consegnato tutti i fornitori', visible : flag ,icon : 'fas fa-newspaper',menu:menuId,color:'#8000ff'},
  
    },
    {
        path        : '/order_all_categories',
        name        : 'supplierOrder5',
        component   : order5,
        meta        : { name : 'Ordinato/Consegnato tutte le categorie', visible : flag ,icon : 'fas fa-shapes',menu:menuId,color:'darkgreen'},
  
    },
        
    
]
export default routes